<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li">
                <div class="form__ttl">변경 신청 항목</div>
                <div class="checkbox_line">
                  <label class="checkbox">
                    <input type="checkbox" v-model="params.isMember" :true-value="1" :false-value="-1">
                    <span class="label"><span>연구원 및 보조원 변경</span></span>
                  </label>
                </div>
              </li>
              <li class="form__li">
                <div class="checkbox_line">
                  <label class="checkbox">
                    <input type="checkbox" v-model="params.isLocation" :true-value="1" :false-value="-1">
                    <span class="label"><span>소재지 변경</span></span>
                  </label>
                </div>
              </li>
              <li class="form__li">
                <div class="form__in">
                  <div class="checkbox_line">
                    <label class="checkbox">
                      <input type="checkbox" v-model="params.isOther" :true-value="1" :false-value="-1">
                      <span class="label"><span>기타</span></span>
                    </label>
                  </div>
                  <div class="inline">
                    <label class="input">
                      <input type="text" placeholder="기타 내용을 입력해 주세요." v-model="params.otherDesc" :disabled="params.isOther === -1">
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm on" @click="requestChange()">변경 신청</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      params: {
        labNo: this.$route.query.labNo,
        isMember: -1,
        isLocation: -1,
        isOther: -1,
        otherDesc: ''
      }
    }
  },
  created: function () {

  },
  watch: {
    'params.isOther': function (val) {
        if (val === -1) {
          this.params.otherDesc = ''
        }
    }
  },
  methods: {
    requestChange: async function () {
      if (this.params.isMember === -1 && this.params.isLocation === -1 && this.params.isOther === -1) {
        this.$Util.modalAlert({message: '신청 항목을 선택해 주세요.'})
        return false
      }

      if (this.params.isOther === 1 && this.params.otherDesc === '') {
        this.$Util.modalAlert({message: '기타 내용을 입력해 주세요.'})
        return false
      }

      const res = await this.$LabSvc.requestChange(this.params);
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.$Util.modalAlert({message: '신청 되었습니다.'}, function () {
          this.$router.go(-1)
        })
      }
    }
  }
}
</script>
